const config = require("thorConfig");

class ConfigService {

    private options: Object;

    constructor() {
        this.options = config;
    }

    public $get() {
        return this.options;
    }
}

angular
    .module("thor.core.config.service", [])
    .provider("configService", [
        ConfigService
    ]);
